import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defineMessages } from 'react-intl';
import * as clientActions from '../actions/client';

import * as analyticsActions from '../actions/analytics';
import CapacitorSkeletonIfLoading from '../components/capacitor/SkeletonIfLoading';

import { imgixImageUrl, LIVESTREAM_EVENT_IMAGE_DIMS } from '../lib/imgix';

const messages = defineMessages({
  metaTitle: {
    id: 'livestream-events.meta.title',
    defaultMessage: 'IDAGIO Concerts',
  },
  metaDescription: {
    id: 'livestream-events.meta.description',
    defaultMessage: 'IDAGIO Concerts',
  },
  metaKeywords: {
    id: 'livestream-events.meta.keywords-2',
    defaultMessage: 'idagio concerts, live, livestream, live stream, video, feed, stream, artists',
  },
});

class LivestreamEventsOverview extends PureComponent {
  static propTypes = {
    children: PropTypes.object,
    track: PropTypes.func.isRequired,
  };

  static onDataFetch(store, params, location, intl) {
    store.dispatch(
      clientActions.setHelmet({
        title: intl.formatMessage(messages.metaTitle),
        description: intl.formatMessage(messages.metaDescription),
        keywords: intl.formatMessage(messages.metaKeywords),
        ogImage: imgixImageUrl({
          path: '/assets/web/live-fallback.jpg',
          width: LIVESTREAM_EVENT_IMAGE_DIMS.w,
          height: LIVESTREAM_EVENT_IMAGE_DIMS.h,
        }),
        canonicalRoute: '/live',
      })
    );
  }

  onOrderComplete = (order, event) => {
    const { track } = this.props;
    const trackingProps = {
      liveEvent: event.slug,
      liveStreamEventType: event.type,
      context: 'whatsOn',
      orderId: order.id,
      purchasePlatform: order.platform,
    };

    track('Completed Ticket Purchase', trackingProps);
  };

  render() {
    return (
      <div className="u-page-container">
        <CapacitorSkeletonIfLoading>
          {React.cloneElement(this.props.children, { onOrderComplete: this.onOrderComplete })}
        </CapacitorSkeletonIfLoading>
      </div>
    );
  }
}

export default connect(null, {
  track: analyticsActions.track,
})(LivestreamEventsOverview);
